"use client";

import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { PermissionsProvider } from "@/context/permissions-context";
import { useSession } from "@/hooks/use-session";
import { useMemo, useState, useEffect } from "react";

export function PermissionsProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const user = useSelector((state: RootState) => state.user.user);
  const { data: sessionUser, isPending: isSessionPending } = useSession();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const permissions = useMemo(() => {
    if (!mounted || !user?.role?.scopes) {
      return [];
    }
    return user.role.scopes
      .map((scope) => scope.code)
      .filter((code): code is string => Boolean(code));
  }, [mounted, user?.role?.scopes]);

  // The session resolves after hydration and is bridged into Redux a tick later.
  // Until both have landed the permission list is empty, which is "not known yet",
  // not "denied".
  const isReady = mounted && !isSessionPending && (!sessionUser || Boolean(user));

  return (
    <PermissionsProvider permissions={permissions} isReady={isReady}>
      {children}
    </PermissionsProvider>
  );
}
